import React from "react";
import Button from "../button/Button";
import Skills from "../skills/Skills";

const Card = () => {
    return (<div className="card">
        <nav>
            <div className="skills" style={{marginBottom:40}}>
                <Skills
                    title="Formation"
                    description="2020-2024 : Centrale Méditerranée"
                    icon="graduation-cap"
                />
                <Skills
                    title="Soft-Skills"
                    description="Gestion de projet SCRUM & Agile,
                                Communication,
                                Sens des responsabilités"
                    icon="gears"
                />
                <Skills
                    title="Projets"
                    description="Cliquer pour découvir mes projets..."
                    icon="computer"
                />
            </div>
            <Button link="https://www.figma.com/file/DaRPw2SeV8fWeZLXjHCGZk/DA-Pro?type=design&node-id=0%3A1&mode=dev" />
        </nav>
        <div className="content">
            <h1>Arthur Louradou</h1>
            <h2>Élève ingénieur Centralien</h2>
            <br/>
            <p>Passioné de nouvelles technologies, j’ai largement investi mon temps et mes projets en lien avec la transformation numérique, en conscience et avec respect des enjeux sociétaux de notre temps.</p>
            <br/>
            <p>Étudiant à l’École Centrale de Marseille, j’ai développé autonomie, rigueur et savoirs en lien avec les technologies numériques au service de la vision que j’aspire à partager. C’est l’objet de ce portfolio.</p>
        </div>
    </div>);
}

export default Card;
